exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ReactTypeformEmbed{position:relative !important;height:65vh !important}.typeform-container.display{display:block}.typeform-container.invisible{display:none}.project-summary__progress.progress-wrap.progress-wrap--big{margin-bottom:10}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/scss/component/assessments/assessment.scss
// module id = 2886
// module chunks = 3